// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file non_medical_master/get_non_medical_master.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { NonMedicalMaster } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetNonMedicalMasterRequest
 */
export class GetNonMedicalMasterRequest extends Message<GetNonMedicalMasterRequest> {
  /**
   * Unique identifier for the non-medical master record
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetNonMedicalMasterRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetNonMedicalMasterRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNonMedicalMasterRequest {
    return new GetNonMedicalMasterRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNonMedicalMasterRequest {
    return new GetNonMedicalMasterRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNonMedicalMasterRequest {
    return new GetNonMedicalMasterRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetNonMedicalMasterRequest | PlainMessage<GetNonMedicalMasterRequest> | undefined, b: GetNonMedicalMasterRequest | PlainMessage<GetNonMedicalMasterRequest> | undefined): boolean {
    return proto3.util.equals(GetNonMedicalMasterRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetNonMedicalMasterResponse
 */
export class GetNonMedicalMasterResponse extends Message<GetNonMedicalMasterResponse> {
  /**
   * The non-medical master record
   *
   * @generated from field: com.neulink.pharmacy.NonMedicalMaster non_medical_master = 1;
   */
  nonMedicalMaster?: NonMedicalMaster;

  constructor(data?: PartialMessage<GetNonMedicalMasterResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetNonMedicalMasterResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "non_medical_master", kind: "message", T: NonMedicalMaster },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNonMedicalMasterResponse {
    return new GetNonMedicalMasterResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNonMedicalMasterResponse {
    return new GetNonMedicalMasterResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNonMedicalMasterResponse {
    return new GetNonMedicalMasterResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetNonMedicalMasterResponse | PlainMessage<GetNonMedicalMasterResponse> | undefined, b: GetNonMedicalMasterResponse | PlainMessage<GetNonMedicalMasterResponse> | undefined): boolean {
    return proto3.util.equals(GetNonMedicalMasterResponse, a, b);
  }
}

